import script from "./Plugins.vue?vue&type=script&setup=true&lang=js"
export * from "./Plugins.vue?vue&type=script&setup=true&lang=js"

import "./Plugins.vue?vue&type=style&index=0&id=43943b64&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43943b64"]])

export default __exports__